module.exports = __webpack_public_path__ + "img/bread-slice.cbaa9be6.svg";